import { z } from 'zod'
import { attemptId } from './attempt.ts'
import { puzzleView } from './puzzle.ts'
import { userId } from './user.ts'

export const runId = z.uuid()
export type RunId = z.infer<typeof runId>

export const runStatus = z.enum(['active', 'complete', 'abandoned'])
export type RunStatus = z.infer<typeof runStatus>

export const startRunInput = z.object({
  length: z.number().int().min(1).max(50).default(10),
})

/**
 * A run is a fixed sequence of puzzles chosen up front. Picking them eagerly
 * makes a run resumable and reproducible, rather than something that quietly
 * re-rolls when you reload the page.
 */
export const run = z.object({
  id: runId,
  userId,
  status: runStatus,
  length: z.number().int().min(1),
  currentIndex: z.number().int().min(0),
  correctCount: z.number().int().min(0),
  startedAt: z.date(),
  endedAt: z.date().nullable(),
  /** Set once the player has seen the end-of-run summary. */
  acknowledgedAt: z.date().nullable(),
})

export type Run = z.infer<typeof run>

/** Everything the board needs in one round trip. */
export const runState = z.object({
  run,
  /** Null once the run is finished. */
  puzzle: puzzleView.nullable(),
  /** The open attempt for `puzzle`, to pass back to `submitMove`. */
  attemptId: attemptId.nullable(),
})

export type RunState = z.infer<typeof runState>
